// src/AudioSpectrum/effects/noteFountain.js
import { getHSLColor } from '../colorUtils.js';

export const drawNoteFountain = (ctx, frequencyData, width, height, fountainRef) => {
  ctx.fillStyle = 'rgba(10, 10, 30, 0.08)';
  ctx.fillRect(0, 0, width, height);
  
  const fountainCount = 4;
  const fountainWidth = width / (fountainCount-1);
  
  for (let f = 0; f < fountainCount; f++) {
    const fountainX = (f + 0.5) * fountainWidth;
    const freqStart = Math.floor((f / fountainCount) * frequencyData.length);
    const freqEnd = Math.floor(((f + 1) / fountainCount) * frequencyData.length);
    const avgValue = frequencyData.slice(freqStart, freqEnd).reduce((a, b) => a + b, 0) / (freqEnd - freqStart);
    
    if (avgValue > 35) {
      const noteCount = Math.floor(avgValue / 35);
      for (let i = 0; i < noteCount; i++) {
        const noteTypes = ['♪', '♫', '♬', '♩', '♭', '♯'];
        fountainRef.current.push({
          x: fountainX + (Math.random() - 0.5) * 35,
          y: height - 90,
          vx: (Math.random() - 0.5) * 3,
          vy: -(avgValue / 255) * 12 - Math.random() * 4,
          life: 1.0,
          decay: 0.01,
          size: Math.random() * 2 + 2,
          color: getHSLColor((Math.random() * 120) % 360, 85, 70),
          gravity: 0.06,
          trail: [],
          noteSymbol: noteTypes[Math.floor(Math.random() * noteTypes.length)],
          rotation: Math.random() * Math.PI * 2,
          rotationSpeed: (Math.random() - 0.5) * 0.1,
          type: 'note'
        });
      }
    }
  }
  
  // 음표 파티클 업데이트
  fountainRef.current = fountainRef.current.filter(particle => {
    particle.x += particle.vx;
    particle.y += particle.vy;
    particle.vy += particle.gravity;
    particle.life -= particle.decay;
    particle.rotation += particle.rotationSpeed;
    
    if (particle.life > 0 && particle.y < height + 50) {
      ctx.globalAlpha = particle.life;
      ctx.save();
      ctx.translate(particle.x, particle.y);
      ctx.rotate(particle.rotation);
      
      // 음표 기호 그리기
      ctx.fillStyle = particle.color;
      ctx.font = `${particle.size * 8}px serif`;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      
      // 글로우 효과
      ctx.shadowColor = particle.color;
      ctx.shadowBlur = particle.size;
      ctx.fillText(particle.noteSymbol, 0, 0);
      ctx.shadowBlur = 0;
      
      ctx.restore();
      ctx.globalAlpha = 1.0;
      return true;
    }
    return false;
  });
};